import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

const navLinks = [
  { to: '/', key: 'home', stage: 'stageDiscover' },
  { to: '/about', key: 'about', stage: 'stageUnderstand' },
  { to: '/free-angel', key: 'freeAngel', stage: 'stageDiscover' },
  { to: '/portal-practice', key: 'portalPractice', stage: 'stagePractice' },
  { to: '/og/qi-healing', key: 'qiHealing', stage: 'stagePractice' },
  { to: '/qualification', key: 'qualification', stage: 'stageBegin' },
  { to: '/journey', key: 'journey', stage: 'stageBegin' },
  { to: '/weekly-practice', key: 'weeklyPractice', stage: 'stagePractice' },
  { to: '/evidence', key: 'evidence', stage: 'stagePractice' },
  { to: '/living-node', key: 'livingNode', stage: 'stagePractice' },
  { to: '/ai-mentor', key: 'aiMentor', stage: 'stageContinue' },
  { to: '/library', key: 'library', stage: 'stageUnderstand' },
  { to: '/membership', key: 'membership', stage: 'stageBegin' },
  { to: '/dashboard', key: 'dashboard', stage: 'stageContinue' },
  { to: '/contact', key: 'contact', stage: 'stageContinue' },
];

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navBg = scrolled
    ? 'bg-background-50/95 backdrop-blur-sm border-b border-foreground-100/50'
    : 'bg-transparent border-b border-transparent';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${navBg}`}>
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-14">
        <Link to="/" className="flex items-center gap-3 whitespace-nowrap cursor-pointer">
          <span
            className={`text-lg tracking-wide transition-colors duration-500 ${scrolled ? 'text-foreground-900' : 'text-foreground-800'}`}
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            {t('common.portalName')}
          </span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-0.5">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.to;
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`whitespace-nowrap px-2.5 py-1.5 rounded-md text-sm transition-colors cursor-pointer ${
                  isActive
                    ? 'bg-foreground-100 text-foreground-900'
                    : 'text-foreground-500 hover:text-foreground-800 hover:bg-foreground-50'
                }`}
              >
                {t(`nav.${link.key}`)}
              </Link>
            );
          })}
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-foreground-600 cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`} />
        </button>
      </nav>

      {/* Mobile nav */}
      {mobileOpen && (
        <div className="md:hidden border-t border-foreground-100/50 bg-background-50 px-4 py-3 flex flex-col gap-0.5">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.to;
            return (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`whitespace-nowrap px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer ${
                  isActive
                    ? 'bg-foreground-100 text-foreground-900'
                    : 'text-foreground-500 hover:text-foreground-800 hover:bg-foreground-50'
                }`}
              >
                {t(`nav.${link.key}`)}
              </Link>
            );
          })}
        </div>
      )}
    </header>
  );
}